import { Button } from '@apps/web/components/ui/button';

export function CoverageEmptyState({
    variant,
    onClearFilters,
}: {
    readonly variant: 'no-caregivers' | 'no-availability-data' | 'no-matches';
    readonly onClearFilters?: () => void;
}) {
    if (variant === 'no-caregivers') {
        return (
            <div className="text-muted-foreground py-10 text-center text-sm">
                No caregivers in this organization yet.
            </div>
        );
    }
    if (variant === 'no-availability-data') {
        return (
            <div className="py-10 text-center">
                <p className="text-sm font-medium">No availability data yet</p>
                <p className="text-muted-foreground mx-auto mt-1 max-w-md text-sm">
                    Phoebe records caregiver availability from EHR sync, text
                    conversations, and calls. As it comes in, this page shows
                    who can work when, by area.
                </p>
            </div>
        );
    }
    return (
        <div className="py-10 text-center">
            <p className="text-sm font-medium">No caregivers match</p>
            {onClearFilters ? (
                <Button
                    variant="outline"
                    size="sm"
                    className="mt-3"
                    onClick={onClearFilters}
                >
                    Clear filters
                </Button>
            ) : null}
        </div>
    );
}
